import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login.vue'
import Home from '../components/Home.vue'
import Welcome from '../components/Welcome.vue'
import Sandreport from '../components/Sandreport.vue'
import Stondreport from '../components/Stondreport.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
import VueSession from 'vue-session'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
Vue.use(VueSession)
Vue.use(VueGoodTablePlugin);
Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)


const routes = [
  {
    path: '/Welcome',
    name: 'Welcome',
    component: Welcome
  },
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/sandreport',
    name: 'Sandreport',
    component: Sandreport
  },
  {
    path: '/stondreport',
    name: 'Stondreport',
    component: Stondreport
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
